<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style>
    #app {
        font-family: 'Nunito', 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
